import { render, staticRenderFns } from "./BillSlicing.vue?vue&type=template&id=73b36042&"
import script from "./BillSlicing.vue?vue&type=script&lang=js&"
export * from "./BillSlicing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports